import { Input } from 'antd';
import { GrispiInputProps } from '..';
import GrispiInputContainer from '../GrispiInputContainer';

type GrispiTextAreaInputProps = Omit<GrispiInputProps<'TEXTAREA'>, 'type' | 'options' | 'isNewValueAllowed'>;

export default function GrispiTextAreaInput({
    antdProps,
    containerProps,
    onChange,
    value,
    ...rest
}: GrispiTextAreaInputProps) {
    return (
        <GrispiInputContainer {...containerProps}>
            <Input.TextArea
                allowClear
                {...antdProps}
                onChange={({ target: { value } }) => onChange(value || null)}
                value={value}
                {...rest}
            />
        </GrispiInputContainer>
    );
}
